import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BarCodeCategory, DecodedQrCode, FocusInputType, InteractionType, LocalService, PageKey } from '../../../service/local.service';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss']
})
export class QrcodeComponent implements OnInit {
  categoryCode: BarCodeCategory = BarCodeCategory.Me; qrCode: string = ''; message: string = '';
  lstSectionConfigKeys: string[] = ["barcode"]; ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None;
  elementIds: any = {
    qr_code_input: 'qr_code_input'
  };
  directCategories: BarCodeCategory[] = [BarCodeCategory.Sellers];
  lstQrCodeNeeded: BarCodeCategory[] = [BarCodeCategory.Product];
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private router: Router, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.configurationManagementService.ensurePageActions(PageKey.QrCode);
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.onInitiate();
    });
  }

  onInitiate() {
    setTimeout(() => {
      this.localService.onFocusNextInput(this.elementIds.qr_code_input, FocusInputType.TextBox);
    }, 500);

    if (this.localService.redirectUrl && this.localService.redirectUrl.startsWith(this.localService.barCodePrefix)) {
      this.qrCode = this.localService.redirectUrl;
      this.localService.redirectUrl = '';
      this.onInput();
    }
  }

  onKeyUp() {
    //this.message = '';
  }

  onInput(isTimeDelayRequired = false) {
    setTimeout(() => {
      this.message = '';
      this.localService.qrCodeRedirected = null;
      this.qrCode = this.qrCode ? this.qrCode.trim() : '';
      if (this.qrCode && this.qrCode != '') {
        let qrCode = this.localService.getDecodedQrCode(this.qrCode);
        if (qrCode.isValid) {
          this.onRoute(qrCode);
        } else {
          this.onSearchProduct(qrCode);
        }
      }
    }, isTimeDelayRequired ? 500 : 0);
  }

  onQrScanned(value) {
    this.qrCode = value ? value.trim() : '';
    this.onInput();
  }

  onReset() {
    this.localService.onSetInput(this.elementIds.qr_code_input, FocusInputType.TextBox);
    this.localService.onFocusNextInput(this.elementIds.qr_code_input, FocusInputType.TextBox);
    this.qrCode = '';
  }

  onSearchProduct(decodedQrCode: DecodedQrCode) {
    let bizId = this.localService.getBusinesssIdIfSingle();
    if (bizId != '') {
      this.localService.qrCodeRedirected = decodedQrCode;
      this.router.navigate(['/billing', this.localService.selected.countryCode, this.localService.selected.user, InteractionType.Business, bizId, '0']);
    } else {
      this.message = this.localService.languageContent.barcode.invalid;
      this.onReset();
    }
  }

  onRoute(decodedQrCode: DecodedQrCode) {
    if (this.directCategories.length > 0 && this.directCategories.indexOf(decodedQrCode.barCodeCategory) > -1) {
      switch (decodedQrCode.barCodeCategory) {
        case BarCodeCategory.Sellers: {
          this.router.navigate(['/sellers', decodedQrCode.countryCode, decodedQrCode.value]);
        } break;
      }
    } else {
      switch (decodedQrCode.barCodeCategory) {
        case BarCodeCategory.Me: {
          this.router.navigate(['/user', decodedQrCode.countryCode, decodedQrCode.value, InteractionType.Business]);
        } break;
        case BarCodeCategory.Billing: {
          if (this.localService.selected.user) {
            this.router.navigate(['/billing', decodedQrCode.countryCode, this.localService.selected.user, this.localService.isBusinessAvailable(decodedQrCode.businessId) ? InteractionType.Business : InteractionType.User, decodedQrCode.businessId, decodedQrCode.value]);
          } else {
            this.router.navigate(['/rv', decodedQrCode.countryCode, decodedQrCode.value]);
          }
        } break;
        case BarCodeCategory.Product:
        case BarCodeCategory.SerialNumber: {
          this.localService.qrCodeRedirected = decodedQrCode;
          if (decodedQrCode.businessId) {
            this.router.navigate(['/billing', decodedQrCode.countryCode, this.localService.selected.user, this.localService.isBusinessAvailable(decodedQrCode.businessId) ? InteractionType.Business : InteractionType.User, decodedQrCode.businessId, '0']);
          } else {
            this.localService.onNavigateToPage(PageKey.BillingBusiness);
          }
        } break;
        case BarCodeCategory.Business: {
          if (!decodedQrCode.businessId || decodedQrCode.businessId == '')
            decodedQrCode.businessId = decodedQrCode.value;
          if (this.localService.isBusinessAvailable(decodedQrCode.businessId))
            this.router.navigate(['/seller', decodedQrCode.countryCode, this.localService.selected.user, InteractionType.Business, decodedQrCode.businessId]);
          else
            this.router.navigate(['/billing', decodedQrCode.countryCode, this.localService.selected.user, InteractionType.User, decodedQrCode.businessId, '0']);
        } break;
        case BarCodeCategory.Products: {
          this.router.navigate(['/products', decodedQrCode.countryCode, this.localService.selected.user, InteractionType.Business, decodedQrCode.businessId]);
        } break;
        case BarCodeCategory.SerialNumbers: {
          this.router.navigate(['/serial-numbers', decodedQrCode.countryCode, this.localService.selected.user, InteractionType.Business, decodedQrCode.businessId, decodedQrCode.productId, 0]);
        } break;
        case BarCodeCategory.Payment: {
          this.router.navigate(['/payments', decodedQrCode.countryCode, this.localService.selected.user, decodedQrCode.interactionType, decodedQrCode.businessId]);
        } break;
      }

      //this.configurationManagementService.getQrDetails(decodedQrCode).subscribe(result => {
      //  
      //  let status: Status = parseInt(result.key);
      //  if (status != Status.Success) {
      //    this.onReset();
      //  }
      //  if (status != Status.None) {
      //    if (status == Status.Success && this.lstQrCodeNeeded.indexOf(decodedQrCode.barCodeCategory) > -1) {
      //      this.localService.qrCodeRedirected = decodedQrCode;
      //    }

      //    switch (decodedQrCode.barCodeCategory) {
      //      case BarCodeCategory.Me: {
      //        switch (status) {
      //          case Status.Success: {
      //            this.router.navigate(['/user', decodedQrCode.countryCode, result.v1]);
      //          } break;
      //        }
      //      } break;
      //      case BarCodeCategory.Billing: {
      //        switch (status) {
      //          case Status.Success: {
      //            this.router.navigate(['/billing', decodedQrCode.countryCode, result.v1, result.v2]);
      //          } break;
      //        }
      //      } break;
      //      case BarCodeCategory.Product: {
      //        switch (status) {
      //          case Status.Success: {
      //            this.router.navigate(['/billing', decodedQrCode.countryCode, result.v1, '0']);
      //          } break;
      //          case Status.InActive: {
      //            this.message = this.localService.languageContent.barcode.product_inactive;
      //          } break;
      //        }
      //      } break;
      //      case BarCodeCategory.Business:
      //      case BarCodeCategory.Products: {
      //        switch (status) {
      //          case Status.Success: {
      //            this.router.navigate(['/' + (decodedQrCode.barCodeCategory == BarCodeCategory.Business ? 'seller' : 'products'), decodedQrCode.countryCode, result.v1]);
      //          } break;
      //          case Status.InActive: {
      //            this.message = this.localService.languageContent.barcode.biz_inactive;
      //          } break;
      //        }
      //      } break;
      //    }
      //  }
      //});
    }
  }
}
